import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import {SortingsInterface} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';
import {casinoGamesStore} from 'app/store/global';
import FirstLevelItem from 'app/components/pages/casino/FirstLevelItem';
import {isDesktopSmall} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import {openCasinoMobileSheetPopup} from 'app/utils/modals/openCasinoMobileSheetPopup';

interface EmptyGamesProps {
    sortings?: SortingsInterface[]
    sortingValue: string
    onClick?: () => void
}

export default class FirstLevelSort extends PureComponent<EmptyGamesProps> {
    isActive = (value: string): boolean => {
        const {sortingValue} = this.props;
        return sortingValue === value;
    };

    changeSortActive = (value: string): void => {
        casinoGamesStore.changeSelectSorting(value);
    };

    handleOpenCasinoMobileSheet = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();
        const sortByHeadingLabel = I18n.t('sort_by').replace(':', '');
        const {sortings, onClick} = this.props;

        openCasinoMobileSheetPopup({
            onAfterRowSelect: onClick,
            renderRows: closeSheet => (sortings ?? []).map(sorting => <FirstLevelItem
                className={`casino-mobile-sheet__row${this.isActive(sorting.value) ? ' casino-mobile-sheet__row--active' : ''}`}
                onClick={closeSheet}
                value={sorting.value}
                name={I18n.t(`sortings.${sorting.value}`)}
                key={sorting.value}
            />),
            title: sortByHeadingLabel
        });
    };

    render(): React.ReactNode {
        const {sortings, onClick} = this.props;
        return <div className="sorting-az">
            {isDesktopSmall()
                ? <>
                    <span className="sorting-az__title">{I18n.t('sort_by')}</span>
                    <div className="sorting-az__buttons" onClick={onClick}>
                        {sortings && sortings.map(sorting => <FirstLevelItem value={sorting.value}
                            key={`sorting_first_${sorting.id}`}
                            className={`button-sorting-az ${this.isActive(sorting.value) ? 'active' : '' }`}
                            name={I18n.t(`sortings.${sorting.value}`)}
                        />)}
                    </div>
                </>
                : <button className="button-filter-select button-filter-select--sorting" onClick={this.handleOpenCasinoMobileSheet}>
                    <SpriteIcon name="#svg-sorting" className="svg-default" />
                </button>}
        </div>;
    }
}
